import BmiMixin                   from '../../../../support/bmi_mixin'
import GlucoseIndicatorMixin      from '../../../../support/glucose_indicator_mixin'
import WizardController           from '../../../wizard_controller'
import BloodPressureCheckMixin    from '../../../../support/blood_pressure_check_mixin'
import mixin                      from '../../../../support/mixin'

export default class extends mixin(
  WizardController,
  BmiMixin,
  GlucoseIndicatorMixin,
  BloodPressureCheckMixin
) {

  static targets = [
    ...super.targets,
    'historicHba1c',
    'historicHba1cAddButton',
    'historicHba1cHint',
    'historicHba1cTemplate',
    'historicHba1cWrapper',
    'urineTestStrip'
  ]

  static values = {
    ...super.values,
    historicHba1cLimit: Number
  }

  static outlets = [
    'consultation-note'
  ]

  initialize() {
    super.initialize()
    this.elevatedBpMessage = null
  }

  // ==== Controllers

  // ==== Actions

  // ==== Nested Forms

  addHistoricHba1cItem() {
    this.addNestedForm({
      template: this.historicHba1cTemplateTarget,
      list:     this.historicHba1cTargets,
      wrapper:  this.historicHba1cWrapperTarget
    })

    this.toggleTarget(this.historicHba1cHintTarget, true)

    if (this.historicHba1cTargets.length >= this.historicHba1cLimitValue) {
      this.historicHba1cAddButtonTarget.classList.add(this.hideClass)
    }
  }

  removeHistoricHba1cItem({ currentTarget }) {
    this.removeNestedForm({
      button:    currentTarget,
      list:      this.historicHba1cTargets,
      wrapper:   this.historicHba1cWrapperTarget,
      allowNone: true
    })

    if (this.historicHba1cTargets.length < this.historicHba1cLimitValue) {
      this.historicHba1cAddButtonTarget.classList.remove(this.hideClass)
    }

    if (this.historicHba1cTargets.length === 0) {
      this.toggleTarget(this.historicHba1cHintTarget, false)
    }
  }

  // === Toggles

  toggleUrineTestStrip({ currentTarget }) {
    this.toggleTarget(this.urineTestStripTarget, currentTarget.checked)
  }

  // ==== Getters

  // ==== Setters

  /**
   * @param {any} message
   */
  set warningMessage(message) {
    this.testEscalationWarningsTarget.querySelector('p').innerHTML = message
  }

  // === Private

}
